module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('PageHeader'), _vm._v(" "), _c('h1', {
    staticClass: "text-center responsive dark-header"
  }, [(_vm.getSubscription === 'funkwerks' && !_vm.isSuccessPage) ? _c('img', {
    staticClass: "funkwerks-image",
    attrs: {
      "src": require("../assets/images/funkwerks_logo.png")
    }
  }) : _vm._e(), _vm._v(" "), (_vm.getSubscription === 'hopbomb' && !_vm.isSuccessPage) ? _c('img', {
    staticClass: "hopbomb-image",
    attrs: {
      "src": require("../assets/images/hopbomb_logo.png")
    }
  }) : _vm._e(), _vm._v(" "), (_vm.getSubscription === 'bronxbrewery' && !_vm.isSuccessPage) ? _c('img', {
    staticClass: "bronxbrewery-image",
    attrs: {
      "src": require("../assets/images/bronxbrewery_logo.png")
    }
  }) : _vm._e(), _vm._v(" "), (_vm.getSubscription === 'cider' && !_vm.isSuccessPage) ? _c('img', {
    staticClass: "cider-image",
    attrs: {
      "src": require("../assets/images/cider_logo.png")
    }
  }) : _vm._e(), _vm._v(" "), (_vm.getSubscription === 'kuiuanchorage' && !_vm.isSuccessPage) ? _c('img', {
    staticClass: "kuiu-anchorage-image",
    attrs: {
      "src": require("../assets/images/anchorage_logo.png")
    }
  }) : _vm._e(), _vm._v("\n    " + _vm._s(_vm.pageTitleText) + "\n    "), (_vm.pageTitleSubtext && !_vm.isSuccessPage) ? _c('div', {
    class: _vm.subtextClass
  }, [_vm._v(_vm._s(_vm.pageTitleSubtext))]) : _vm._e(), _vm._v(" "), (_vm.getSubscription === 'kuiuanchorage' && _vm.isSuccessPage) ? _c('div', {
    staticClass: "success-page-subtext"
  }, [_vm._v("DOWNLOAD THE APP")]) : _vm._e()]), _vm._v(" "), (_vm.busy) ? _c('h2', [_vm._v("loading...")]) : _vm._e(), _vm._v(" "), _c(_vm.currentView, {
    tag: "component",
    on: {
      "success": _vm.setView,
      "login": _vm.routeLogin,
      "register": _vm.routeZipAndAge
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d147c230!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Home.vue
// module id = 412
// module chunks = 1